import { render, staticRenderFns } from "./SportsNavigation.vue?vue&type=template&id=8fbf0ad6&"
import script from "./SportsNavigation.vue?vue&type=script&lang=js&"
export * from "./SportsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SportsNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VList,VListGroup,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VNavigationDrawer,VProgressCircular})
